import BaseService from '@root/core/class/BaseService';

class signUpServices extends BaseService {
  public postSignUp = (body: Record<string, any>) => {
    return this.post('/signup', body);
  };
  public postUploadImg = (body: Record<string, any>) => {
    return this.post('/upload', body);
  };
  public postUploadLicense = (body: Record<string, any>) => {
    return this.post('/uploadLicense', body, {
      // headers: {
      //   charset: 'euc-kr'
      // }
    });
  };
}
export default new signUpServices('/api/v1/warehouse', true);
